<template>
  <div class="search__inner">
    <h1 class="heading__h1 search__heading" v-html="searchText"></h1>

    <div class="search__columns">
      <div class="search__filters">
        <h2 class="search__filtersHeading">
          {{ translations.filterOptions }}
        </h2>

        <search-filter-panel
          data-vue-component
          :options="authors"
          :field-name="'autoren'"
          :title-text="translations.allAuthors"
          :has-count="true"
          :has-search="true"
          :filter-text="translations.searchFilter"
          :search-placeholder="translations.Suchbegriff"
          @filters-changed="filtersChanged"
        />

        <search-filter-panel
          data-vue-component
          :options="categories"
          :field-name="'themen'"
          :title-text="translations.allCategories"
          :has-search="false"
          :filter-text="translations.searchFilter"
          :search-placeholder="translations.Suchbegriff"
          @filters-changed="filtersChanged"
        />
      </div>

      <search-results-lister
        data-vue-component
        :loading="loading"
        :mehr-visible="mehrVisible"
        :articles="posts"
        :more-text="translations.more"
        :read-more-text="translations.readMore"
        @load-more="loadMore"
      />
    </div>
  </div>
</template>

<script>

import SearchFilterPanel from './SearchFilterPanel.vue';
import SearchResultsLister from './SearchResultsLister.vue';

export default {
  components: {
    'search-filter-panel':   SearchFilterPanel,
    'search-results-lister': SearchResultsLister,
  },
  props:
  {
    apiUrl: {
      type: String,
      default: '',
    },
    searchWord: {
      type: String,
      default: null,
    },
    articles: {
      type: Array,
      default: null,
    },
    authors: {
      type: Array,
      default: null,
    },
    categories: {
      type: Array,
      default: null,
    },
    translations: {
      type: Object,
      default: null,
    },
    perPage: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      debug: false,
      posts: null,
      mehrVisible: true,
      loading: false,
      searchParams: {
        themen: null,
        autoren: null,
      },
      initialPostCount: 0,
      numberOfPosts: 0,
    };
  },
  computed: {
    // a computed getter
    searchText()
    {
      if (!this.posts) return this.translations.searchNoResults;

      const count  = this.posts.length;
      let sucher = '';
      let text   = '';

      if (count) {
        sucher = this.translations.searchResults;
        if (count === 1) {
          sucher = this.translations.searchResult;
        }
        text = `${count} ${sucher}`;
      }
      else {
        text = this.translations.searchNoResults;
      }

      text +=  ` <strong>${this.searchWord}</strong>`;

      if (this.searchParams.autoren || this.searchParams.themen) {
        text +=  ` (${this.translations.filtered})`;
      }

      return text;
    },
  },
  mounted()
  {
    // this.debug && console.log('search Wrapper - mounted');
    this.posts         = this.articles ? [...this.articles] : null;
    this.numberOfPosts = this.posts ? this.posts.length : 0;
    if (!this.posts) this.mehrVisible = false;
  },
  methods:
  {
    filtersChanged(filterType, optionsChecked)
    {
      this.debug && console.log('filtersChanged', filterType, optionsChecked);

      if (filterType === 'themen') {
        this.searchParams.themen = optionsChecked.join(',');
      }

      if (filterType === 'autoren') {
        this.searchParams.autoren = optionsChecked.join(',');
      }

      this.numberOfPosts = this.perPage;
      this.doSearch();
    },

    loadMore()
    {
      this.debug && console.log('load more');
      this.numberOfPosts += this.perPage;
      this.doSearch();
    },

    doSearch()
    {
      this.loading     = true;
      this.mehrVisible = false;

      let queryString = `perPage=${this.numberOfPosts}`;

      if (this.searchParams.autoren) {
        queryString += `&authorFilter=${this.searchParams.autoren}`;
      }

      if (this.searchParams.themen) {
        queryString += `&categoryFilter=${this.searchParams.themen}`;
      }

      if (this.searchWord) {
        queryString += `&sFilter=${this.searchWord}`;
      }

      this.debug && console.log('queryString', queryString);

      // let postsBefore = this.posts ? this.posts.length : 0;

      fetch(`${this.apiUrl}bwpspace/v1/search_posts_for_thumbs?${queryString}`)
        .then((response) => response.json())
        .then((data) => {

          this.posts = data || [];
          this.loading = false;
          if (this.posts && this.posts.length >= this.perPage) {
            if (this.posts.length < this.numberOfPosts) {
              this.mehrVisible = false;
            } else {
              this.mehrVisible = true;
            }
          }
        })
        .catch((error) => {
          this.debug && console.log(error);
          this.loading = false;
          // this.orderChanged = false;
        });
    },
  },
};

</script>

<style scoped lang="scss">
</style>
